/* DON'T EDIT THIS FILE: edit original and run build again */ export const axisFullLabel =
  "AXIS SOCIEDAD GERENTE DE FONDOS COMUNES DE INVERSION S.A";
